import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Products, company, followUs, list, support } from './constants';
import { useNavigate,  useLocation} from 'react-router-dom';
import { getLeads } from "../../redux/actions/userSubscription";
import { validPaths } from '../../common/constants';



const Footer = () => {

    const [courses, setCourses] = useState([])
    const user_id = useSelector((store) => store?.profileDetails?.id);
    const role_type = useSelector((store) => store?.useSubscription?.role_type);
    const all_courses = useSelector(store => store?.courses?.allCourses)

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();

    useEffect(() => {
        setCourses(all_courses)
    }, [])

    const handleRoute = (link) => {
        window.open(link)
    }

    const handleNavigation = (link) => {
        navigate(`/${link}`, { target: '_blank' })
    }
    
    const customStyle = {
        gridColumn: 'span 1.5',
      };



      
    return (
        location.pathname !== "/pricing" && location.pathname !== "/verification" && !location.pathname.includes('/verify/certificate') && location.pathname !== "/" && location.pathname !== '/knowledge-graph' && location.pathname !== '/hackathon' && location.pathname !== '/onboarding' && location.pathname !== '/onboarding/loader' && !validPaths.includes(location.pathname) && location.pathname !== '/onboarding/analysis' && location.pathname !== '/set-password' && location.pathname !== '/halloffame/' && !location.pathname.includes('/halloffame/') && location.pathname !== '/recruiter' && location.pathname !== '/recruiter/' && location.pathname !== '/recruiter/results' && location.pathname !== '/recruiter/profile' && location.pathname !== '/recruiter/signup' && location.pathname !== '/leaderboard' ? 
       
        <div className='bg-[#061016]  text-white py-5 lg:py-10 flex flex-col md:flex-row'>
            <div className='flex flex-col items-center md:items-start md:w-[28%] md:ml-10 md:mr-3 lg:mr-0 lg:ml-16'>
                <div className='flex flex-col items-center md:items-start '>
                    <div className='flex justify-center items-center gap-2 mb-3'>
                        <div className='flex flex-col justify-center items-center'>
                            <div className='w-fit flex items-center  rounded-md gap-2' onClick={()=> navigate('/courses')}>
                                <img alt="a green and blue play button on a black background" src="https://assets.learntube.ai/files/post-payment-updates/image%2011.svg?updatedAt=1728356261811" loading="eager"   className='w-[42px] h-[42px]'/>
                                <p className='text-xl font-semibold'>LearnTube.ai</p>
                            </div>
                            <p className='text-xs font-normal  tracking-wide mt-2 md:mt-4 '>Copyrights 2026 CareerNinja</p>
                        </div>
                        <div className='h-full w-[160px] md:w-[210px] border-l-2 border-[#797979]'>
                            <img alt="a black and white logo with the words developed with youtube" src="https://developers.google.com/static/youtube/images/developed-with-youtube-sentence-case-light.png" className=' w-full h-full object-cover'></img>
                        </div>
                    </div>


                    <button
                        onClick={() => {
                        dispatch(
                        getLeads({
                            user_id: user_id ? user_id : 0,
                            user_plan: role_type ? role_type : "basic",
                            product_id: 3,
                            product_name: "LearnTubeX",
                            product_type: "subscription",
                            is_visit: false,
                        }));
                        navigate("/pricing");}}
                        className="flex lg:hidden items-center justify-center rounded bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 px-5 py-[10px] text-center text-lg font-bold text-black shadow-md transition duration-150 ease-in-out hover:bg-orange-400 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-400 active:shadow-lg"
                    >
                        <div className='mr-3 w-6 h-6 md:h-8 md:w-8'>
                            <img
                                className=" rounded-full w-full h-full"
                                alt="coin icon"
                                src="https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860"
                            />
                        </div>
                        Upgrade To Pro
                    </button>
                    <p className='text-sm w-[90%] text-center my-4 lg:mt-0 font-normal md:text-left'>LearnTube is India’s first AI-driven Ed Tech Platform where you’ll find 300+ courses and 900+ Hiring partners under 1 platform.</p>
                    <button
                        onClick={() => {
                        dispatch(
                        getLeads({
                            user_id: user_id ? user_id : 0,
                            user_plan: role_type ? role_type : "basic",
                            product_id: 3,
                            product_name: "LearnTubeX",
                            product_type: "subscription",
                            is_visit: false,
                        }));
                        navigate("/pricing");}}
                        className="lg:flex hidden items-center justify-center rounded bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 px-5 py-[10px] text-center text-lg font-bold text-black shadow-md transition duration-150 ease-in-out hover:bg-orange-400 hover:text-white hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:bg-yellow-400 active:shadow-lg"
                    >
                        <div className='mr-3 w-6 h-6 md:h-8 md:w-8'>
                            <img
                                className=" rounded-full w-full h-full"
                                alt="coin icon"
                                src="https://assets.learntube.ai/files/skill_page/pro.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1660918183860"
                            />
                        </div>
                        Upgrade To Pro
                    </button>
                </div>
                <div>
                    <p className='text-center mb-2 mt-1 lg:mt-5 lg:mb-2 md:text-left'>Download our app now!</p>
                    <div className='w-[13rem]  cursor-pointer' onClick={()=>{
                        window.open('https://play.google.com/store/apps/details?id=com.learntube')
                    }}>
                        <img alt="a sign that says get on google play" src="https://storage.googleapis.com/learntube-web-assets/files/Optimized_LandingPagev3/google-play-badge__1__webp.png"  className='w-full h-full object-cover'/>
                    </div>
                </div>
                <div className='w-[17rem] h-[4.6rem] md:w-[16rem] lg:w-[17rem] my-4 flex items-center pl-3 pr-4 py-1 border rounded-xl'>
                    <div className='w-[45px] h-[45px] bg-white rounded-full mr-2'>
                        <img alt="a white circle with the google logo on it" src="https://assets.learntube.ai/files/About-us/unnamed.webp?updatedAt=1685425840630"  className='w-full h-full object-center rounded-full'/>
                    </div>
                    <div className='pr-2 md:pr-1 lg:pr-2 flex-1'>
                        <p className='text-xs pl-2 font-medium tracking-wider'>Google Reviews</p>
                        <div className='flex items-center justify-evenly'>
                            <p className='text-lg font-bold'>4.7</p>
                            <div>
                                <img src="https://assets.learntube.ai/files/About-us/Star_6.svg?updatedAt=1685425989505" alt="star icon" />
                            </div>
                            <div>
                                <img src="https://assets.learntube.ai/files/About-us/Star_6.svg?updatedAt=1685425989505" alt="star icon"  />
                            </div>
                            <div>
                                <img src="https://assets.learntube.ai/files/About-us/Star_6.svg?updatedAt=1685425989505"  alt="star icon" />
                            </div>
                            <div>
                                <img src="https://assets.learntube.ai/files/About-us/Star_6.svg?updatedAt=1685425989505"  alt="star icon" />
                            </div>
                            <div>
                                <img src="https://assets.learntube.ai/files/About-us/Star_10.svg?updatedAt=1685425942166"  alt="star icon" />
                            </div>
                        </div>
                        <p className='text-xs opacity-70 tracking-wider pl-2'>Based on 388 reviews</p>
                    </div>
                </div>
                <div className='flex gap-1 mt-2'>
                <div className='w-[89px] h-[102px]'>
                        <img alt="the logo for the 2012 gvs cup" src="https://assets.learntube.ai/files/About-us/gsv.png?updatedAt=1687163269620"  className='w-full h-full object-fill '/>
                    </div>
                    <div className='ml-1 mr-1 w-[89px] h-[102px]'>
                        <img  alt="the logo for top 10 in EdTech" src="https://assets.learntube.ai/files/About-us/Group_6957.svg?updatedAt=1685426177243"  className='w-full h-full object-fill '/>
                    </div>
                    <div className=' w-[89px] h-[102px]'>
                        <img alt="a red and white logo with the words,'illustious start up of" src="https://assets.learntube.ai/files/About-us/Group_8565.png?updatedAt=1687162559097"  className='w-full h-full object-fill '/>
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-2 pl-6 lg:pl-12 pr-3 mt-10 md:mt-0 md:grid-cols-3 md:grid-rows-2 lg:grid-rows-1 lg:grid-cols-5 md:flex-1'>
                <div className='h-auto'>
                    <p className='text-base font-semibold mb-5'>Company</p>
                    <ul className='flex flex-col text-sm opacity-70'>
                        {company.map((item) => (
                            <li key={item.id} className='mb-3'><span className='cursor-pointer' onClick={() => handleRoute(item.link)}>{item.name}</span></li>
                        ))}
                    </ul>
                </div>
                <div className='hidden h-auto lg:block'>
                    <p className='text-base font-semibold mb-5'>Courses</p>
                    <ul className='flex flex-col text-sm opacity-70'>
                        {courses?.map((item) => (
                            <li key={item?.id} className='mb-3' ><span className='cursor-pointer' onClick={() => handleNavigation(item?.course_slug)}>{item?.['course-name']}</span></li>
                        ))}
                    </ul>
                </div>

                <div className='h-auto lg:ml-3'>
                    <p className='text-base font-semibold mb-5'>Follow Us</p>
                    <ul className='flex flex-col text-sm opacity-70'>
                        {followUs.map((item) => (
                            <li key={item.id} className='mb-3'><span className='cursor-pointer' onClick={() => handleRoute(item.link)}>{item?.name}</span></li>
                        ))}
                    </ul>
                </div>

                <div className='h-auto mt-3 md:mt-0'>
                    <p className='text-base font-semibold mb-5'>Support</p>
                    <ul className='flex flex-col text-sm opacity-70'>
                        {support.map((item) => (
                            <li key={item.id} className='mb-3 w-auto'><span className='cursor-pointer' onClick={() => handleRoute(item.link)}>{item?.name}</span></li>
                        ))}
                    </ul>
                </div>
                
                <div className='h-auto mt-3 md:mt-0'>
                    <p className='text-base font-semibold mb-5'>Products</p>
                    <ul className='flex flex-col text-sm opacity-70'>
                        {Products.map((item) => (
                            <li key={item.id} className='mb-3'><span className='cursor-pointer' onClick={() => handleRoute(item.link)}>{item?.name}</span></li>
                        ))}
                    </ul>
                </div>
            </div>
        </div> : null
  )
}

export default Footer